var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactSalesBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1506,
    height: 397,
    viewBox: "0 0 1506 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1831_1829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 362.688L124.711 258.431L251.175 310.154L375.828 155.987L501.415 104.257L627.88 207.652L753 155.52L878.997 207.652L1004.58 103.379L1130.17 0.877484L1254.82 51.7224L1381.28 104.257L1506 0V397H0V362.688Z",
    fill: "url(#paint0_linear_1831_1829)",
    fillOpacity: 0.64
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1831_1829",
    x1: 753,
    y1: 479.278,
    x2: 753,
    y2: -217.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white",
    stopOpacity: 0.0676
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "white",
    stopOpacity: 0.2401
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white",
    stopOpacity: 0.4489
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "white",
    stopOpacity: 0.6561
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.8464
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "white",
    stopOpacity: 0.9604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1831_1829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1506,
    height: 397,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSalesBackground);
export default __webpack_public_path__ + "static/media/contact-sales-background.a79752439555e1367dedcb53dabd8af0.svg";
export { ForwardRef as ReactComponent };